import React from "react";
import CommonTableIndexWise from "Components/Common/CommonTableIndexWise";
import { AccessioningSessionScanlogProgressHistoryItem } from "../helper/session.types";

interface ScanProgressHistoryTabProps {
  data: AccessioningSessionScanlogProgressHistoryItem[];
  loading: boolean;
  currentPage: number;
  pageSize: number;
  totalRecords: number;
  onPageChange: (page: number) => void;
}

const ScanProgressHistoryTab: React.FC<ScanProgressHistoryTabProps> = ({
  data,
  loading,
  currentPage,
  pageSize,
  totalRecords,
  onPageChange,
}) => {
  const columns = [
    {
      key: "subjectno",
      label: "Subject No.",
      textCenter: true,
      render: (_: any, row: any) => (
        <div className="fw-bold text-dark">{row.subjectno || "-"}</div>
      ),
    },
    {
      key: "subjectbarcode",
      label: "Subject Barcode",
      textCenter: true,
      render: (_: any, row: any) => (
        <div className="font-monospace fw-semibold text-primary">{row.subjectbarcode || "-"}</div>
      ),
    },
    {
      key: "vaccutainer_status",
      label: "Sample Collection Status",
      textCenter: true,
      render: (_: any, row: any) => {
        const isDone = String(row.vaccutainer_status || row.vacutainerStatus || "").toLowerCase() === "completed";
        return (
          <div className="d-flex justify-content-center">
            {isDone ? (
              <i className="ri-checkbox-circle-fill text-success fs-18"></i>
            ) : (
              <i className="ri-time-line text-warning fs-18"></i>
            )}
          </div>
        );
      },
    },
    {
      key: "aliquot_status",
      label: "Sample Separation Status",
      textCenter: true,
      render: (_: any, row: any) => {
        const status = String(row.aliquot_status || "").toLowerCase();
        const isDone = status === "completed";
        const isPartial = status === "partial";
        return (
          <div className="d-flex justify-content-center">
            {isDone ? (
              <i className="ri-checkbox-circle-fill text-success fs-18"></i>
            ) : isPartial ? (
              <i className="ri-pie-chart-2-fill text-info fs-18" title="Partial Separation"></i>
            ) : (
              <i className="ri-time-line text-warning fs-18"></i>
            )}
          </div>
        );
      },
    },
  ];

  return (
    <CommonTableIndexWise
      columns={columns}
      data={data}
      loading={loading}
      pageSize={pageSize}
      currentPage={currentPage}
      totalRecords={totalRecords}
      onPageChange={onPageChange}
      actions={{}}
    />
  );
};

export default ScanProgressHistoryTab;
